import { useHirerAuth } from '@seek/hirer-auth-react';
import { Actions, type Text, Stack } from 'braid-design-system';
import React from 'react';

import { ButtonLink } from 'src/components';

import type { ButtonProps } from '../../../../../components/Link/Link';

interface Text {
  loggedIn: string;
  loggedOut: string;
}

interface Href {
  loggedIn: string;
  loggedOut: string;
}

interface TrackingProps {
  loggedIn: string;
  loggedOut: string;
}

interface CTAButtonNoLinks {
  text: Text;
  href: Href;
  color?: string;
  center?: boolean;
  tracking: TrackingProps;
}

const CTAButtonNoLinks = ({
  text,
  href,
  color = 'pink',
  center,
  tracking,
  tone,
  ...props
}: CTAButtonNoLinks & Pick<ButtonProps, 'variant' | 'tone'>) => {
  const { authenticated, loading } = useHirerAuth();
  const { loggedIn, loggedOut } = tracking;
  const authTracking = authenticated ? loggedIn : loggedOut;
  const buttonText = authenticated ? text.loggedIn : text.loggedOut;
  const link = authenticated ? href.loggedIn : href.loggedOut;

  return (
    <Stack space="gutter" align={center ? 'center' : 'left'}>
      <Actions>
        <ButtonLink
          color={color}
          tracking={authTracking}
          href={link}
          loading={loading}
          tone={tone || 'neutral'}
          {...props}
        >
          {buttonText}
        </ButtonLink>
      </Actions>
    </Stack>
  );
};

export default CTAButtonNoLinks;
